import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { concatMap, map, skipWhile } from 'rxjs/operators';
import { BrandingService } from '../services/branding.service';

export const pointOfLeaseGuard: CanActivateFn = () => {
  const brandingService = inject(BrandingService);
  const router = inject(Router);

  return brandingService.brandingInfo$.pipe(
    skipWhile(brandingInfo => Object.keys(brandingInfo).length === 0),
    concatMap(() => brandingService.pointOfLeaseAvailable$),
    map(isAvailable => isAvailable ? true : router.createUrlTree(['/']))
  );
};
